<div class="vtr-spinner">
	<fa-icon [icon]="['fal', 'circle-notch']"
		[class]="className"
		[spin]="true"
		role="img"
		aria-label="Spinner"></fa-icon>
</div>
